export const txtButtonContinue = 'Continuar <i class="icon-Arrow-Front"></i>';
export const txtButtonFinish = 'Solicitar visita';
